import CharlyChatMessage from './CharlyChatMessage';

function CharlyChatMessageList({ messages }) {
  if (!Array.isArray(messages)) {
    return <div className="text-muted p-3">Geen berichten beschikbaar</div>;
  }

  return (
    <div className="p-px-3 p-py-2" style={{ minHeight: '100%', boxSizing: 'border-box' }}>
      {messages.map((msg) => (
        <div key={msg.id} data-message>
          {msg['user-input'] && (
            <CharlyChatMessage type="UserInput" text={msg['user-input']} />
          )}
          {msg['agent-answer'] && (
            <CharlyChatMessage type="AgentAnswer" text={msg['agent-answer']} feedback={msg['user-feedback-type']} chatMessageId={msg['id']}/>
          )}
        </div>
      ))}
    </div>
  );
}

export default CharlyChatMessageList;